import * as React from 'react';
import classnames from 'classnames';

import { formatAsElementId } from './Utils';
import { FormComponent } from './Form';
import ErrorBlock from './ErrorBlock';

import { cloneExcept } from 'core/utils';
import { Binding, Result } from 'core/infrastructure';

interface Props<T> extends React.HTMLProps<CheckBox<T>> {
	linkTo: Binding.PropertyPath<T>;
	label?: string;
	boundValue?: boolean;
	onValueChanged?: (value: boolean) => void;
	formId?: string;
}

interface State {
	value?: boolean;
	errorMsg?: string;
}

export class CheckBox<T> extends React.Component<Props<T>, State> implements FormComponent {

	private input = React.createRef<HTMLInputElement>();

	constructor(props: Props<T>) {
		super(props);

		if (typeof props.boundValue !== 'boolean')
			throw new Error('No se puede vincular a un CheckBox una propiedad que no sea de tipo boolean');

		this.state = {
			value: props.boundValue,
			errorMsg: ''
		};
	}

	getPath(): string {
		return Binding.propertyPathToString(this.props.linkTo);
	}

	showErrors(errors: string[]): void {
		this.setState({ errorMsg: errors.join(' ') });
	}

	getValue(): Result<boolean | undefined> {
		this.setState({ errorMsg: '' });
		return Result.ok(this.state.value);
	}

	focus() {
		const inputNode = this.input.current!;
		inputNode.focus();
	}

	render() {

		const props: any = cloneExcept(this.props, ['linkTo', 'boundValue', 'label', 'onValueChanged', 'children', 'formId', 'ref']);

		const classes = classnames({ 'checkbox abc-checkbox': true, 'has-error': !!this.state.errorMsg });
		const inputId = formatAsElementId(this.getPath(), this.props.formId || '');

		const onChange = (e: any) => {
			const checked = e.target.checked;
			this.setState({ value: checked }, () => {
				this.props.onValueChanged?.(checked);
			});
		};

		const subcontrolsStyle: React.CSSProperties = {
			paddingLeft: 40,
			marginTop: 5,
			marginBottom: -10,
			display: this.state.value ? 'block' : 'none'

		};

		const subcontrols = React.Children.count(this.props.children)
			? <div className='col-sm-12' style={subcontrolsStyle}>{this.props.children}</div>
			: null;

		return <div className='form-group'>
			<div className='col-sm-12'>
				<div className={classes}>
					<input id={inputId} ref={this.input} type='checkbox' {...props} checked={this.state.value} onChange={onChange} />
					<label htmlFor={inputId}>{this.props.label || ''}</label>
					<ErrorBlock msg={this.state.errorMsg} />
				</div>
			</div>
			{subcontrols}
		</div>;
	}
}

export type CheckBoxCtor<T> = new (props: Props<T>) => CheckBox<T>;
